import { Model } from 'dva';
import { createSelector } from 'reselect';

export type NotificationsType = 'saveDraftSuccess' | null;

interface NotificationsProps {
  type: NotificationsType;
}

const initialState = {
  type: null,
};

export const showNotification = ({
  type,
}: Pick<NotificationsProps, 'type'>) => ({
  type: 'notifications/show',
  payload: {
    type,
  },
});

export const resetNotification = () => ({
  type: 'notifications/reset',
});

const notifications: Model = {
  namespace: 'notifications',
  state: initialState,
  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
    reset() {
      return initialState;
    },
  },
  effects: {},
};

export const getNotifications: (state: {
  notifications: NotificationsProps;
}) => NotificationsProps = (state) => state.notifications;

export const getNotificationType: (state: {
  notifications: NotificationsProps;
}) => NotificationsType = createSelector(getNotifications, ({ type }) => type);

export default notifications;
